import httpClient from "@/core/axios";

import * as _ from "lodash";

export default {
    namespaced: true,
    state: {
        reservations: null,
        current_reservation: null,
        all_reservation_states: [
            { value: "CHECKED_IN", label: "Current" },
            { value: "EXPECTED", label: "Upcoming" },
            { value: "CHECKED_OUT", label: "Previous" },
            { value: "CANCELLED", label: "Archived" },
            { value: "NO_SHOW", label: "Archived" },
            { value: "OTHER", label: "Archived" }
        ]
    },
    getters: {
        reservations(state) {
            return state.reservations;
        },
        current_reservation(state) {
            return state.current_reservation;
        },
        // Group reservations by state
        reservations_by_states(state) {
            const reservations_map = {};
            _.forEach(state.all_reservation_states, s => {
                if (reservations_map[s.label]) {
                    reservations_map[s.label] = [
                        ...reservations_map[s.label],
                        ..._.orderBy(
                            _.filter(state.reservations, res => {
                                return (
                                    (res.state?.status || "OTHER") === s.value
                                );
                            }),
                            "start",
                            "desc"
                        )
                    ];
                } else {
                    reservations_map[s.label] = _.orderBy(
                        _.filter(state.reservations, res => {
                            return (res.state?.status || "OTHER") === s.value;
                        }),
                        "start",
                        "desc"
                    );
                }
            });
            return reservations_map;
        }
    },
    actions: {
        async fetchReservations(context) {
            return httpClient
                .get("/api/guest/app/:app_uuid/user/reservations")
                .then(data => context.commit("SET_RESERVATIONS", data));
        },
        async fetchCurrentReservation(context) {
            return httpClient
                .get("/api/guest/app/:app_uuid/user/reservations/current")
                .then(data => context.commit("SET_CURRENT_RESERVATION", data));
        }
    },
    mutations: {
        SET_RESERVATIONS(state, data) {
            state.reservations = data;
        },
        SET_CURRENT_RESERVATION(state, data) {
            state.current_reservation = data;
        }
    }
};
